module.exports = __webpack_public_path__ + "media/images/pc/top/kodawari_dress-015fbcfe5726f303c461d54e26a9a111.webp";